import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import ax from "../config";
import {openNotification} from "../../components/helpers/notification";


const initialState = {
  subscribes: null,
  currentSubscribe: null,
  isLoading: false,
}

export const getSubs = createAsyncThunk(
  'subscribes/getSubs',
  async (payload, {rejectWithValue}) => {
    try {
      const { data } = await ax.get(`/api/recurrent`, {params: payload.value})
      return data
    } catch (error) {
      return rejectWithValue(`Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`)
    }
  }
)

export const subscribesAction = createAsyncThunk(
  'subscribes/SubsAction',
  async (payload, {rejectWithValue}) => {
    try {
      let data;
      const url = '/api/recurrent';
      switch (payload.flag) {
        case 'get':
          ({ data } = await ax.get(url, { params: payload.value }))
          return data

        case 'post':
          ({ data } = await ax.post(url, payload.value))
          break;

        case 'put':
          ({ data } = await ax.put(url, payload.value))
          break;

        case 'unSubscribe':
          ({ data } = await ax.get(url + '/cancel/' + payload.value))
          break;

        default:
          break;
      }
    } catch (error) {
      // dispatch(setBookingListLoading(false))
      return rejectWithValue(`Ошибка ${error.response.data.errorMessages[0].errorCode}. ${error.response.data.errorMessages[0].errorMessage}`)
    }
  }

)

const SubscribesSlice = createSlice({
  name: 'Subscribes',
  initialState,
  reducers: {

  },
  extraReducers: (builder) => {
    builder.addCase(subscribesAction.fulfilled, (state, action) => {
      state.subscribes = action.payload
      state.isLoading = false
    })
    builder.addCase(subscribesAction.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(subscribesAction.rejected, (state, action) => {
      state.isLoading = false
      openNotification({
        type: "error",
        message: action.payload
      })
    })
  }
})

export const {} = SubscribesSlice.actions
export default SubscribesSlice.reducer